module.exports = __webpack_public_path__ + "assets/images/media-error-b6d09b8fdf31ebb833ae5a831c837edb.png";